import React from 'react';

import PropTypes from 'prop-types';

import * as APPDATA from '@/constants/pcConstAppData';

import './Diagram.less';

class Diagram extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pcState: undefined,
    };
  }

  // new method to hide & show data
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.currentState !== prevState.pcState) {
      return {
        pcState: nextProps.currentState,
      };
    }

    // No state update necessary
    return null;
  }

  render() {
    const {skipPrime, scaleSize, moreThan50ml} = this.props;
    const {pcState} = this.state;
    // eslint-disable-next-line no-nested-ternary
    const scale = scaleSize === 'small' ? '-small' : scaleSize === 'medium' ? '-medium' : '-large';
    const className = !moreThan50ml ? 'animation-diagram' : 'animation-diagram-more-than50';
    const skipPrimeClassname =
      skipPrime && pcState.toLowerCase() === 'priming'
        ? `${className}-concentrating${scale}`
        : `${className}-${pcState.toLowerCase()}${scale}`;
    return <div className={skipPrimeClassname} />;
  }
}
export default Diagram;

Diagram.propTypes = {
  currentState: PropTypes.any,
  scaleSize: PropTypes.oneOf(['small', 'medium', 'large']),
  moreThan50ml: PropTypes.bool,
  skipPrime: PropTypes.bool,
};
Diagram.defaultProps = {
  currentState: '',
  scaleSize: 'small',
  moreThan50ml: false,
  skipPrime: false,
};

Diagram.STATUS = {
  IDLE: APPDATA.PC_IDLE_STATE,
  PRIMING: APPDATA.PC_PRIMING_STATE,
  CONCENTRATING: APPDATA.PC_CONCENTRATING_STATE,
  DIAFILTRRATING: APPDATA.PC_DIAFILTRATING_STATE,
  PREPARING: APPDATA.PC_PREPARING_STATE,
  RECOVERING_AIR: `${APPDATA.PC_RECOVERING_STATE}-${APPDATA.ENUM.RECOVERY_OF_LIQUID.Air}`,
  REVOCERING_BUFFFER: `${APPDATA.PC_RECOVERING_STATE}-${APPDATA.ENUM.RECOVERY_OF_LIQUID.Buffer}`,
  RECOVERING_AIR_BUFFER: `${APPDATA.PC_RECOVERING_STATE}-${APPDATA.ENUM.RECOVERY_OF_LIQUID.Air_Buffer}`,
  REVERSE_DIAFILTRATING: APPDATA.PC_REVERSE_DIAFILTRATING_STATE,
};
